export default __webpack_public_path__ + "99c4f7adcacb1bf2a9606c6f7e341327.mp3";